<template>
  <div class="section__content project">
    <div class="project__bar" role="button" :aria-pressed="isOpen" @click="toggleOpen">
      <h3 class="project__title">{{ content.title }}</h3>
      <button class="project__button">
        <Icon :id="getToggleId()" />
      </button>
    </div>
    <DropDown :is-open="isOpen">
      <div class="row project__dropdown project__description">
        <ContentRaw class="-span-7 row__item" :html="content.content"></ContentRaw>
        <aside class="row__item -span-4 project__documents--block">
          <img v-if="content.image !== false" :src="content.image" alt="Logo de l'entreprise" />
          <div v-if="content.documents !== false" class="project__documents">
            <h4 class="project__documents--title">{{ getDocumentsTitle() }}</h4>
            <ul>
              <li
                v-for="(document, documentIndex) in content.documents"
                :key="documentIndex"
                class="project__documents--item"
              >
                <a :href="getDocumentLink(document)" target="_blank"
                  ><Icon :id="'document'" /><span>{{ document.label }}</span></a
                >
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </DropDown>
  </div>
</template>
<script>
import ContentRaw from '@/components/content/ContentRaw.vue'
import { Icon } from '@/components/global'

export default {
  name: 'Projects',
  contentKey: 'projects',
  components: { ContentRaw, Icon },
  props: {
    content: { type: Object, required: true }
  },
  data() {
    return {
      isOpen: false,
      imageValid: true,
      documentLink: ''
    }
  },
  methods: {
    getToggleId() {
      return this.isOpen ? 'less' : 'more'
    },
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    getDocumentLink(document) {
      if (document.type_de_document === 'link') {
        return document.link
      }
      return document.document
    },
    getDocumentsTitle() {
      return this.$lang.current === 'fr' ? 'Documents liés au projet' : 'Project documents'
    }
  }
}
</script>
